/**
 * Adapptio library for processing blueprints.
 *
 * @package lib-blueprint
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BP, INamedConfigResolver } from "@adapptio/lib-blueprint";
import { IIntegrationDefRegistry } from "../registries";

/**
 * Creates Integration Params Resolver
 */
export function createIntegrationParamsResolver(
	integrationDefRegistry: IIntegrationDefRegistry
): INamedConfigResolver {
	return {
		getOptsSchemaByName: (name: string) => {
			const integrationDef = integrationDefRegistry.get(name);
			if (!integrationDef) {
				return null;
			}

			return BP.Const.Map({
				value: integrationDef.optionsSchema,
				provideKeyToScopeMetaAs: "secretsEnv"
			});
		},

		getNameList: () => {
			return integrationDefRegistry.getItemList().map((def) => ({
				name: def.name,
				label: def.label
			}));
		}
	};
}
